function isIpOrLocalhost(host) {
  return (
    host === "localhost" ||
    /^(\d{1,3}\.){3}\d{1,3}$/.test(host)
  );
}

/**
 * 从主机名取「可挂 t/n 子域」的主域：先剥掉首段 t{ts}|n{ts}，再取根域。
 * 例：t1769366600.localhost → localhost；n1779.xxx.com → xxx.com
 */
export function extractMainDomain(hostname) {
  if (!hostname || typeof hostname !== "string") return "";
  let host = hostname.trim().toLowerCase();
  const parts = host.split(".").filter(Boolean);
  if (parts.length === 0) return "";

  if (/^[tn]\d+$/i.test(parts[0])) {
    host = parts.slice(1).join(".") || parts[0];
  }

  if (isIpOrLocalhost(host)) return host;

  const rest = host.split(".").filter(Boolean);
  if (rest.length <= 2) return host;
  return rest.slice(-2).join(".");
}
